// DevHub CUSTOM — i18n "search" namespace (search page, search modal, home hero search).
// See ./common.ts for the convention.
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const searchMessages = createTranslationRef({
  id: 'devhub.search',
  messages: {
    placeholder: 'Search docs, services, APIs, templates...',
    ariaLabel: 'Search the DevHub',
    noResultsFor: 'No results for “{{term}}”',
    searching: 'Searching…',
    unavailable: 'Search is unavailable right now',
    // Shown instead of a false "no results" when the search index is still building (cold start).
    warming: 'Search is warming up — the index is still building. Try again in a moment.',
    // Result-kind badges — distinguish a catalog entity, a whole page/doc, and a
    // jump-to-a-heading section within a page.
    resultKind: {
      entity: 'Entity',
      page: 'Page',
      section: 'Section',
      // Descriptor on a doc-group header (e.g. "Azure DevOps · doc").
      doc: 'doc',
    },
    page: {
      resultType: 'Result Type',
      softwareCatalog: 'Software Catalog',
      documentation: 'Documentation',
      entity: 'Entity',
      kind: 'Kind',
      lifecycle: 'Lifecycle',
    },
    modal: {
      searchInDoc: 'Search in {{doc}}…',
      search: 'Search',
      inThisDoc: 'In this doc',
      everywhere: 'Everywhere',
      searchOnlyWithin: 'Search only within {{doc}}',
      noResults: 'No results.',
      noResultsInDoc: 'No results in {{doc}}.',
      noResultsHint: 'Check your spelling, or try fewer / more general words.',
      searchEverywhere: 'Search all of the DevHub instead',
      browsePrompt: 'Or browse',
      didYouMean: 'Did you mean',
      startTypingDoc: 'Start typing to search within {{doc}}',
      startTypingAll: 'Start typing to search across the catalog, docs, and APIs',
      catalog: 'Catalog',
      docs: 'Docs',
      apis: 'APIs',
      filterAll: 'All',
      filterDocs: 'Docs',
      filterCatalog: 'Catalog',
    },
    // ── Command palette (Cmd+K commands layered above live search) ──
    palette: {
      group: {
        recent: 'Recent',
        navigate: 'Navigate',
        actions: 'Actions',
        matches: 'Go to / Do',
      },
      nav: {
        home: 'Home',
        catalog: 'Catalog',
        docs: 'Documentation',
        guides: 'Getting Started',
        resources: 'Resources',
        selfService: 'Self Service',
        techRadar: 'Tech Radar',
        landscape: 'Landscape',
        news: 'News',
        community: 'Community',
        mcpCatalog: 'MCP Catalog',
        settings: 'Settings',
        adminOverview: 'Admin · Overview',
        adminAnalytics: 'Admin · Analytics',
        adminCuration: 'Admin · Curation',
        adminAccess: 'Admin · Access',
      },
      action: {
        toggleTheme: 'Toggle theme',
        switchToDark: 'Switch to dark mode',
        switchToLight: 'Switch to light mode',
        openSettings: 'Open Settings',
        openChangelog: 'Open changelog',
      },
    },
  },
  translations: {
    de: () => import('./de/search'),
  },
});
